import React, {FC} from "react"
import styled from "styled-components"
import {Body} from "@irati/ui/src/Typography"
import {RouterLink} from "@irati/ui/src/Link"

interface Props {
  label?: string | null
  imageUrl: string
  roundelBackgroundColor?: string
  link: string
}

const Roundel: FC<Props> = ({label, imageUrl, roundelBackgroundColor, link}) => {
  return (
    <RouterLink to={link}>
      <Container>
        <RoundelImageContainer>
          <Image src={imageUrl} alt={label ?? ""} />
          <BackgroundCircle backgroundColor={roundelBackgroundColor} />
        </RoundelImageContainer>
        {label && <Body>{label}</Body>}
      </Container>
    </RouterLink>
  )
}

export default Roundel

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  text-align: center;
  margin: 8px 16px;
  width: 128px;

  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    width: 162px;
    margin: 24px 36px;
  `}
`

const RoundelImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  position: relative;
  width: 100%;
  height: 128px;

  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    height: 162px;
  `}
`

const Image = styled.img`
  z-index: 1;
  position: relative;
  transition: transform 0.2s;
  max-width: 85%;
  max-height: 85%;

  &:hover {
    transform: scale(1.2);
  }
`

interface BackgroundCircleProps {
  backgroundColor?: string
}

const BackgroundCircle = styled.div<BackgroundCircleProps>`
  top: 0;
  left: 0;
  border-radius: 50%;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 0;
  background-color: ${({backgroundColor, theme}) => (backgroundColor ? backgroundColor : theme.colors.greys.white)};
`
